import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { shadows } = baseVariables;

// Design specs shadow-s (default) / shadow-m (hover), but no such tokens exist yet.
// Using the closest available Global Styles Sass vars: shadowSubtle01 and boxShadowPopover.
const SHADOW_DEFAULT = shadows?.shadowSubtle01 ?? '0 0.25rem 1.25rem 0 rgba(0, 0, 0, 0.08)';
const SHADOW_HOVER = shadows?.boxShadowPopover ?? '0 0.438rem 1.25rem 0 rgba(0, 0, 0, 0.25)';

export const CardLink = styled.a`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-block: 1.5rem;
  padding-inline: 1.5rem;
  background-color: var(--t-brand-bg-color);
  border-radius: var(--t-cards-border-radius, 14px);
  box-shadow: ${SHADOW_DEFAULT};
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:hover {
    box-shadow: ${SHADOW_HOVER};
    text-decoration: none;
  }

  &:focus-visible {
    outline-offset: 2px;
  }
`;

export const LeadingIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  color: var(--t-brand-fg-color);
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  text-align: start;
  padding-block: 0.25rem;
  margin: 0;

  > *:last-child {
    margin-block-end: 0;
  }
`;

export const EyebrowWrapper = styled.div`
  > * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    padding-block: 0;
    margin-block: 0;
  }

  margin-block-end: 0.5rem;
`;

export const SubheaderWrapper = styled.div`
  > * {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-block: 0;
    margin-block: 0;
  }

  margin-block-end: 0.25rem;
`;

export const BodyWrapper = styled.div`
  > * {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-block: 0;
    margin-block: 0;
  }
`;

export const TrailingIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: var(--t-brand-fg-color);
`;
